var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo",class:_vm.appType},[(_vm.link)?_c('router-link',{attrs:{"to":_vm.link}},[(_vm.appType === 'pluska')?_c('pluska-logo'):_c('ufo-logo')],1):_c('figure',[(_vm.appType === 'pluska')?_c('pluska-logo'):_c('ufo-logo')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }